module.exports = __webpack_public_path__ + "static/img/pdf_img.9ba02d87.png";